import { Body1, Box, Caption1 } from '@csp/csp-web-ui';
import { FC } from 'react';
import { NewTabLink } from '../../../common/component/NewTabLink';
import { SystemLinkItemProps } from '../model/SystemLinkItemProps';

export const SystemLinkItem: FC<SystemLinkItemProps> = ({ systemName, description, url, linkLabel, linkProps }) => (
  <Box pb={2} mb={2} borderBottom={1} borderColor="grey.200">
    <Caption1 fontWeight={700} mb={1} component="h6">
      {systemName}
    </Caption1>
    <Body1 mb={{ xs: 1, md: 1.5 }}>{description}</Body1>
    <NewTabLink href={url} size="small" rel="noopener noreferrer" {...linkProps}>
      {linkLabel}
    </NewTabLink>
  </Box>
);
